<template>
  <li v-if="canViewHorizontalNavMenuHeaderLink(item)" class="nav-item"
    :class="{ 'sidebar-group-active active': isActive }">
    <b-link class="nav-link" :to="{ name: item.route }">
      <feather-icon size="14" :icon="item.icon" />
      <span>{{ t(item.title) }}</span>
      <span  class="badge badge-up badge-pill badge-danger" v-if="num!='' && num != 0">{{num}}</span>
      <!-- <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge> -->
    </b-link>
  </li>
</template>

<script>
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { useUtils as useAclUtils } from '@core/libs/acl'
import useHorizontalNavMenuHeaderLink from './useHorizontalNavMenuHeaderLink'
import mixinHorizontalNavMenuHeaderLink from './mixinHorizontalNavMenuHeaderLink'

export default {
  components: {
    BLink,
    BBadge
  },
  mixins: [mixinHorizontalNavMenuHeaderLink],
  props: {
    item: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      timer1: '',
      num:'',
    };
  },
  mounted() {
      //每隔三秒，去查询一次状态
      this.timer1 = setInterval(() => {
        this.getNum();
      }, 1000);
  },

  unmounted() {
    // 清理定时器
    if (this.timer1) {
      clearInterval(this.timer1);
    }
  },

  methods: {

    getNum() {
      const dxqnum = localStorage.getItem('soccer_dxqnum');
      const rqnum = localStorage.getItem('soccer_rqnum');
      const jqnum = localStorage.getItem('soccer_jqnum');

      const cp_dxqnum = localStorage.getItem('soccer_cp_dxqnum');
      const cp_rqnum = localStorage.getItem('soccer_cp_rqnum');
      const cp_jqnum = localStorage.getItem('soccer_cp_jqnum');
      if(this.item.route=='zdDxq'){
          this.num = dxqnum;
      }
      if(this.item.route=='zdRq'){
          this.num = rqnum;
      }
      if(this.item.route=='zdJq'){
          this.num = jqnum;
      }
      if(this.item.route=='cpDxq'){
          this.num = cp_dxqnum;
      }
      if(this.item.route=='cpRq'){
          this.num = cp_rqnum;
      }
      if(this.item.route=='cpJq'){
          this.num = cp_jqnum;
      }
    }
  },



  setup(props) {
    const { isActive, updateIsActive } = useHorizontalNavMenuHeaderLink(props.item)

    const { t } = useI18nUtils()
    const { canViewHorizontalNavMenuHeaderLink } = useAclUtils()

    return {
      isActive,
      updateIsActive,

      // ACL
      canViewHorizontalNavMenuHeaderLink,

      // i18n
      t,
    }
  },
}
</script>
<style lang="css" scoped>

/* 定义一个闪烁动画 */
@keyframes blink {

/* 从0%开始到100%，‌通过opacity属性在1（‌完全不透明）‌和0（‌完全透明）‌之间交替 */
0%,
100% {
  opacity: 1;
}

50% {
  opacity: 0;
}
}

/* 应用闪烁动画到一个类 */
.blinking {
/* 使用无限次重复闪烁动画 */
animation: blink 0.5s infinite;
}
</style>